import TextCurrency from '@atoms/TextCurrency';
import { Text, View } from '@components/primitives';
import appStyles from '@root/appStyles';
import colors from '@theme/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface WithdrawalTotalProps {
  transferAmount?: number;
}

const WithdrawalTotal: React.FC<WithdrawalTotalProps> = ({ transferAmount = 0 }) => {
  const { t } = useTranslation('common');

  return (
    <View style={appStyles.amountContainer}>
      <Text testID="lblWithdrawTotal" variant="sm-bold" flex={1}>
        {t('withdrawalPage.withdrawalTotal')}
      </Text>
      <TextCurrency
        variant="sm-bold"
        amountCurrency={transferAmount || 0}
        showCurrencySymbol
        style={{ color: colors.success.cactus }}
      />
    </View>
  );
};

export default WithdrawalTotal;
